import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import * as _ from "lodash";

import { globalConst } from "../../helpers/constants";
import { ResponseData } from "../../http/api";

export interface TablePagination {
  limit: number;
  page: number;
  field?: string;
  order?: string;
}

/**
 * action - Nome da ação (definida de acordo com cada componente que vá a tabela)
 * routerLink - Rota para qual será direcionado o evento
 * queryParams - Parâmetros para ser enviado na rota, quando utilizada roda
 * data - Quando não for utilizado rota sera enviado todo o objeto
 * tooltip - Lavel que aparecerá ao passar o mouse por cima
 * icon - Icone que será exibido
 *
 */
export interface TableAction {
  action: string;
  routerLink: any;
  queryParams?: any;
  data?: any;
  tooltip: string;
  icon: string;
}

export interface TableCheck {
  checked: boolean;
  id: any;
  all?: boolean;
  data?: any;
}
/**
 * value - Nome do campo no banco de dados
 * showValue - Valor a ser exibido
 * orderBy - Informa se o campo será ordenável
 * size - Largura do campo
 * type - Segue os valores definido em fieldValue()
 * hidden - Informa se o campo sera exibido ou não na tabela.
 */
export interface ColumnField {
  value: string;
  showValue: string;
  orderBy: boolean;
  size: number;
  type?: string;
  hidden?: boolean;
  canCheckAll?: boolean;
}

export interface ColumnOrder {
  field: string;
  order: string;
}

@Component({
  selector: "app-pln-table",
  templateUrl: "./pln-table.component.html",
  styleUrls: ["./pln-table.component.scss"],
})
export class PlnTableComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() dataSource: ResponseData;
  @Input() displayedColumns: ColumnField[] = [];
  @Input() tableActions: TableAction[] = [];
  @Input() selectedCheck: any[] = [];

  @Input() currentPage = 1;
  @Output() paginationEmitter = new EventEmitter();
  @Output() actionEmitter = new EventEmitter();
  @Output() checkEmitter = new EventEmitter();

  columnOrder: ColumnOrder = null;

  itemsPerPage = globalConst.pagination.itemsPerPageDefault;
  itemsToShow = globalConst.pagination.itemsToShow;
  // currentPage = 1;
  totalPages = 0;
  allPages: number[] = [];
  pagesToShow: number[] = [];
  totalPagesToShow = globalConst.pagination.pagesToShowDafault;

  constructor() {}

  static fieldValue = () => {
    return {
      chargeType: "charge-type",
      boolean: "boolean",
      monetary: "monetary",
      date: "date",
      percentual: "percentual",
      externalDocumentStatus: "external-document-status",
      internalDocumentStatus: "internal-document-status",
      firstUpper: "first-upper",
      cpfCnpj: "cpf-cnpj",
      vacancyStatus: "vacancy-status",
      vacancyCurriculumStatus: "vacancy-curriculum-status",
      company: "company",
      budgetStatus: "budget-status",
      dismissalChecklistStatus: "dismissal-checklist-status",
      budgetRequestStatus: "budget-request-status",
      contractStatus: "contract-status",
      codeRevision: "code-revision",
      printType: "print-type",
      activeInactive: "active-inactive",
      deleted: "deleted",
      usedFor: "usedFor",
      mobilePhoneNumberStatus: "mobile_phone_number_status",
      phone: "phone",
      externalOccurrenceStatus: "externalOccurrenceStatus",
      status: "status",
      requestStatus: "requestStatus",
    };
  };

  ngOnChanges(changes: SimpleChanges): void {
    this.totalPages = this.dataSource
      ? this.dataSource.totalPages < 1
        ? 1
        : this.dataSource.totalPages
      : 0;
    this.calcPagesToShow();
  }

  ngOnInit() {
    this.calcPagesToShow();
  }

  emitPagination() {
    this.paginationEmitter.emit({
      limit: this.itemsPerPage,
      page: this.currentPage,
      ...(this.columnOrder
        ? {
            field: this.columnOrder.field,
            order: this.columnOrder.order,
          }
        : ""),
    } as TablePagination);
  }

  emitAction(action: TableAction, data: any) {
    const body = {
      ...action,
      data: data,
      queryParams: action.routerLink
        ? {
            id: data[
              this.displayedColumns.find((obj) => obj.value === "id").value
            ],
          }
        : "",
    };

    this.actionEmitter.emit(body);
  }

  emitCheck(event: any, data: any) {
    this.checkEmitter.emit({ checked: event.checked, id: data.id, all: false });
  }

  changeCheck(event: any, data: any) {
    if (event.checked) {
      this.selectedCheck.push(data.id);
    } else {
      this.selectedCheck = this.selectedCheck.filter(
        (obj: any) => obj !== data.id
      );
    }
  }

  verifyHasCheck(data: any) {
    return this.selectedCheck.find((obj) => obj.id == data.id) !== undefined
      ? true
      : false;
  }

  changeOrdination(field: string, order: string) {
    this.columnOrder = { field, order };
    this.emitPagination();
  }

  changeItensPerPage() {
    this.currentPage = 1;
    this.emitPagination();
  }

  goToPage(page) {
    this.currentPage = page;
    this.emitPagination();
  }

  calcPagesToShow() {
    this.allPages = [];
    this.pagesToShow = [];

    for (let index = 1; index < this.totalPages; index++) {
      const found = this.allPages.find((element) => element === index);
      if (!found) {
        this.allPages.push(index);
      }
    }

    if (this.allPages.length < this.totalPages) {
      this.allPages.push(this.allPages.length + 1);
    }

    if (this.allPages.length > this.totalPagesToShow) {
      if (this.currentPage === 1) {
        this.pagesToShow = this.allPages.slice(0, this.totalPagesToShow);
      }

      if (this.currentPage >= this.totalPagesToShow) {
        const marginPage = this.totalPagesToShow / 2;
        const difLastCurrent = this.allPages.length - this.currentPage;
        const endPage = this.currentPage + this.totalPagesToShow - marginPage;

        let initPage =
          difLastCurrent >= marginPage
            ? this.currentPage - marginPage
            : this.currentPage - (marginPage - difLastCurrent + difLastCurrent);

        initPage =
          endPage > this.allPages.length
            ? initPage - (endPage - this.allPages.length)
            : initPage;
        this.pagesToShow = this.allPages.slice(initPage, endPage);
      } else if (this.currentPage > 1) {
        const rangeDif =
          this.currentPage === 3 || this.currentPage === 4 ? 3 : 2;
        this.pagesToShow = this.allPages.slice(
          this.currentPage - rangeDif,
          this.totalPagesToShow + this.currentPage - rangeDif
        );
      }
    } else {
      this.pagesToShow = this.allPages;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage =
        this.currentPage === 1 ? this.currentPage : this.currentPage - 1;

      this.emitPagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage =
        this.currentPage === this.totalPages
          ? this.totalPages
          : this.currentPage + 1;

      this.emitPagination();
    }
  }

  checkAll() {
    if (_.isEmpty(this.selectedCheck)) {
      this.selectedCheck = this.dataSource.data;
    } else {
      this.dataSource.data.every((resData) => {
        const found = this.selectedCheck.find((obj) => obj.id === resData.id);

        if (found) {
          this.selectedCheck = [];
          return false;
        } else {
          this.selectedCheck.push(resData);
          return true;
        }
      });
    }

    this.checkEmitter.emit({
      all: true,
      data: this.selectedCheck,
    });
  }
}
